// extracted by mini-css-extract-plugin
export default {"offer":"components-Footer-themes-PP-offer__offer--csrGZ","button":"components-Footer-themes-PP-offer__button--sGFYN"};